import { SearchOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import React from 'react';

import PencilFilled from '../../../assets/icons/PencilFilled';
import IconCircleNumber from '../../../components/IconCircleNumber';
import { formatarCnpjCpfIMask } from '../../../helpers/formatador';
import { EditarButton, FiltroInput } from './styles';

const getColumnSearchProps = () => {
  let searchInput;
  return {
    // eslint-disable-next-line react/prop-types
    filterDropdown: filter => (
      <div style={{ padding: 8 }}>
        <FiltroInput
          aria-label="inputSearch"
          ref={node => {
            searchInput = node;
          }}
          value={filter?.selectedKeys?.length ? filter.selectedKeys[0] : ''}
          onChange={e =>
            filter.setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={filter.confirm}
        />
        <Button
          type="primary"
          onClick={filter.confirm}
          icon={<SearchOutlined />}
          style={{ marginRight: 5 }}
        >
          Pesquisar
        </Button>
        <Button className="btn-limpar" onClick={filter.clearFilters}>
          Limpar
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilterDropdownVisibleChange: visible => {
      visible && setTimeout(() => searchInput.select());
    },
  };
};

export const getColumns = (
  handleEditUser,
  filters,
  showModalCnpjsSecundarios
) => {
  // colunas da tabela
  const columns = [
    {
      title: 'Nome',
      dataIndex: 'nome',
      key: 'name',
      width: '30%',
      filteredValue: filters.nome,
      sorter: true,
      ...getColumnSearchProps(),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: '20%',
      filteredValue: filters.email,
      sorter: true,
      ...getColumnSearchProps(),
    },
    {
      title: 'Empresa',
      dataIndex: 'empresa',
      key: 'razao_social',
      width: '25%',
      filteredValue: filters.empresa,
      sorter: true,
      render: (text, record) => (
        <>
          {`${text} `}
          {record.cliente_id_secundarios && (
            <Tooltip placement="right">
              <IconCircleNumber
                qty={record.cliente_id_secundarios.split(',').length}
                onClick={() =>
                  showModalCnpjsSecundarios(record.cliente_id_secundarios)
                }
              />
            </Tooltip>
          )}
        </>
      ),
      ...getColumnSearchProps(),
    },
    {
      title: 'CNPJ',
      dataIndex: 'cnpj',
      key: 'cnpj_resumido',
      width: '20%',
      filteredValue: filters.cnpj,
      sorter: true,
      render: text => formatarCnpjCpfIMask(text).concat('/****-**'),
      ...getColumnSearchProps(),
    },
    {
      title: 'Ações',
      width: '5%',
      render: (text, record) => (
        <EditarButton type="link" onClick={() => handleEditUser(record)}>
          <PencilFilled />
        </EditarButton>
      ),
    },
  ];

  return columns;
};
